<template>
  <div class="wraper">
    <div class="logo">
      <img src="../../../assets/indexImg/logo.png" alt="" />
    </div>
    <p class="loginText">
      众智云擎网页{{ model == 1 ? "注册" : model == 2 ? "登录" : "关联" }}确认
    </p>
    <button class="btn loginsure" @click="sureLogin">
      确认{{ model == 1 ? "注册" : model == 2 ? "登录" : "关联" }}
    </button>
    <!-- <button class="btn gotoindex" @click="goinIndex">进入云擎</button> -->
    <button class="btn logincancel" @click="logincancel">
      取消{{ model == 1 ? "注册" : model == 2 ? "登录" : "关联" }}
    </button>
  </div>
</template>

<script>
import { getSMSFrom } from "@/utils/lib/tools";
import { commonDialog, warningNotify, commonNotify } from "@/utils/lib/toast";
export default {
  created() {
    console.log(this.$baseConfig.getWxCodeAndStateUrl);
    console.log(this.$route);
    console.log(sessionStorage.getItem("model"));
  },
  computed: {
    model() {
      return sessionStorage.getItem(getSMSFrom.SCAN_MODEL);
    },
    identity() {
      return sessionStorage.getItem(getSMSFrom.SCAN_IDENTITY);
    },
  },
  methods: {
    // 确认登录
    sureLogin() {
      let reqBody = {
        code: this.$route.query.code,
        state: this.$route.query.state,
        identity: sessionStorage.getItem(getSMSFrom.SCAN_IDENTITY),
        model: sessionStorage.getItem(getSMSFrom.SCAN_MODEL) * 1,
      };
      console.log(reqBody);
      this.$http.reqPostScanToLogin(reqBody).then((res) => {
        console.log(res);
        if (res.rtncode == 1) {
          if (res.rltcode == 1) {
            commonDialog("完成授权", this, "关闭页面", () => {
              this.closePop();
            });
          } else if (res.rltcode == -99) {
            warningNotify(res.rltdesc, this, 10);
          } else {
            commonDialog(res.rltdesc, this, "关闭页面", () => {
              this.closePop();
            });
          }
        } else {
          commonDialog(res.rtndesc, this, "关闭页面", () => {
            this.closePop();
          });
        }
      });
    },
    // 进入云擎
    goinIndex() {
      this.$router.push(`/`);
    },
    // 取消登录
    logincancel() {
      this.$dialog
        .confirm({
          title: "提示",
          message: "是否取消登录？",
          confirmButtonText: "是",
          cancelButtonText: "否",
        })
        .then(() => {
          this.$http
            .reqPostCloseAuth({
              identity: sessionStorage.getItem(getSMSFrom.SCAN_IDENTITY),
              model: sessionStorage.getItem(getSMSFrom.SCAN_MODEL) * 1,
            })
            .then((res) => {
              console.log(res);
              this.closePop();
            });
        })
        .catch((err) => {
          console.log("网页扫码登录err", err);
        });
    },
    // 关闭页面
    closePop() {
      document.addEventListener(
        "WeixinJSBridgeReady",
        function() {
          // eslint-disable-next-line no-undef
          WeixinJSBridge.call("closeWindow");
        },
        false
      );
      //这个可以关闭ios系统的手机
      // eslint-disable-next-line no-undef
      WeixinJSBridge.call("closeWindow");
    },
  },
};
</script>

<style lang="less" scoped>
.wraper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  top: 50%;
  transform: translateY(-50%);
  .logo {
    width: 179px;
    height: 119px;
    margin-bottom: 35px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .loginText {
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 35px;
  }
  .btn {
    width: 246px;
    height: 40px;
    margin-bottom: 16px;
    border-radius: 20px;
    border: 1px solid #fff;
    font-size: 16px;
    line-height: 34px;
    &.loginsure {
      background-color: #9a7c5a;
      color: #fff;
    }
    &.gotoindex {
      background-color: #fff;
      border-color: #9a7c5a;
      color: #9a7c5a;
    }
    &.logincancel {
      color: #a1a1a1;
      background-color: transparent;
      border-color: transparent;
    }
  }
}
</style>
